<template>
    <div style="font-size: 1rem; border-radius: 4px; margin: auto 10px 12px;">
        <span style="font-size: 1rem; border-radius: 4px;" class="pa-1 label-primary">{{ computed_count }}</span>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                filtered: 0,
                total: 0
            }
        },
        computed: {
            computed_count: function () {
                return Lang.langGet(":filtered / :total rows", {filtered: this.filtered, total: this.total});
            }
        },
        mounted() {
            EaseEventBus.listen('updateJournalCount', (data) => {
                this.filtered = data.filtered;
                this.total = data.total;
            });
        }
    }
</script>
